export default "__VITE_ASSET__CB0DL8$3__"